import { useMutation } from 'react-query';
import Evaporate from 'evaporate';
import superagent from 'superagent';
import CryptoJS from 'crypto-js';

const authSigner = async (signParams, _signHeaders, stringToSign, _dateString, canonicalRequest) => {
  const { applicationId, dispatcherBaseUrl, fileUploadId } = signParams;
  return superagent
    .post(`${dispatcherBaseUrl}/signMultipartUpload`)
    .timeout({
      response: 5000,
      deadline: 5000,
    })
    .send({ toSign: stringToSign, canonicalRequest, fileUploadId })
    .set('Accept', 'application/vnd.bambuser.cdn.v1+json')
    .set('X-Bambuser-ClientVersion', 'LiveShopping uploader 1.0.0')
    .set('X-Bambuser-ClientPlatform', 'browser')
    .set('X-Bambuser-ApplicationId', applicationId)
    .then(response => { return response.body.signature; });
};

const useUploadMediaAssetMutation = (options) => {
  return useMutation({
    mutationFn: async ({ fileItem, progress, isAborted, uploadTicket, onSuccess, onSettled }) => {
      if (!uploadTicket) throw new Error('No upload ticket received');
      const { id, multipart, applicationId, dispatcherBaseUrl } = uploadTicket;
      if (!id || !multipart) throw new Error('No upload ticket received');
      const customAuthParams = { applicationId, dispatcherBaseUrl, fileUploadId: id };
      const { key, bucket, region, path } = multipart;

      let uploadCancelled = false;

      // Perform multipart uploading to AWS S3 bucket
      const evaporate = await Evaporate.create({
        customAuthMethod: authSigner,
        signParams: customAuthParams,
        aws_key: key,
        bucket,
        awsRegion: region,
        sendCanonicalRequestToSignerUrl: true,
        cloudfront: false,
        logging: false,
        partSize: 100 * 1024 * 1024, // individual multipart size 100MB
        computeContentMd5: true,
        cryptoMd5Method: data =>
          CryptoJS.MD5(CryptoJS.lib.WordArray.create(data)).toString(CryptoJS.enc.Base64),
        cryptoHexEncodedHash256: data =>
          CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex),
        onlyRetryForSameFileName: true,
        s3FileCacheHoursAgo: 1,
        maxConcurrentParts: 2,
        s3Acceleration: true,
      });

      await evaporate.add({
        name: path,
        file: fileItem,
        contentType: fileItem.type,
        progress: (_p, stats) => {
          if (uploadCancelled)
            return;
          if (isAborted()) {
            uploadCancelled = true;
            evaporate.cancel(`${bucket}/${path}`);
            return;
          }
          progress(stats.fileSize > 0, stats.totalUploaded, stats.fileSize);
        },
        complete: () => {
          onSuccess?.();
        },
      });

      onSettled?.();
    },
  });
};

export default useUploadMediaAssetMutation;
